import Vue from "vue";
import Vuex from "vuex";

/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading vuex modules
 * -----------------------------------------------------------------------------------------------------------
 */
import account from "@/views/account/store";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    path: "",
    full_path: "",
    langByLanguage: [],
    useLanguage: 'vi',
    permissionUser: {},
    totalNoti: 0,
    socket_connect: true,
  },
  getters: {
    path: (state) => state.path,
    full_path: (state) => state.full_path,
    langByLanguage: (state) => state.langByLanguage,
    useLanguage: (state) => state.useLanguage,
    permissionUser: (state) => state.permissionUser,
    totalNoti: (state) => state.totalNoti,
    socket_connect: (state) => state.socket_connect,
  },
  mutations: {
    setPath(state, path) {
      state.path = path;
    },
    setFullPath(state, full_path) {
      state.full_path = full_path;
    },
    setLangByLanguage(state, langByLanguage) {
      state.langByLanguage = langByLanguage;
    },
    setUseLanguage(state, useLanguage) {
      state.useLanguage = useLanguage;
    },
    setPermissionUser(state, permissionUser) {
      state.permissionUser = permissionUser;
    },
    setTotalNoti(state, totalNoti) {
      state.totalNoti = totalNoti;
    },
    setSocketConect(state, socket_connect) {
      state.socket_connect = socket_connect;
    },
  },
  actions: {
    setPath({ commit }, path) {
      commit("setPath", path);
    },
    setFullPath({ commit }, full_path) {
      commit("setFullPath", full_path);
    },
    setLangByLanguage({ commit }, langByLanguage) {
      commit("setLangByLanguage", langByLanguage);
    },
    setUseLanguage({ commit }, useLanguage) {
      commit("setUseLanguage", useLanguage);
    },
    setPermissionUser({ commit }, permissionUser) {
      commit("setPermissionUser", permissionUser);
    },
    setTotalNoti({ commit }, totalNoti) {
      commit("setTotalNoti", totalNoti);
    },
    setSocketConect({ commit }, socket_connect) {
      commit("setSocketConect", socket_connect);
    },
  },
  modules: {
    account,
  },
});
